import Attachment from '../../UI/Attachment/Attachment'

export const columnsTasks = [
    {
        field: 'task',
        header: 'modals.news_execution.approval.stores_detail.table.header.task',
        isMain: true,
    },
    {
        field: 'role',
        header: 'modals.news_execution.project_specs.details.assignment',
        isMain: true,
    },
    {
        field: 'start_date',
        header: 'modals.filters.label.start_date',
        isMain: true,
    },
    {
        field: 'end_date',
        header: 'modals.news_execution.action.tasks.detail.end_date',
        isMain: true,
    },
    {
        field: 'priority',
        header: 'modals.news_execution.action.tasks.detail.priority',
        isMain: true,
    },
    {
        field: 'completion',
        header: 'modals.news_execution.approval.stores_detail.table.header.completion',
        isMain: true,
    },
]
